'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.FlightAnalysis.Toggle', []).controller('FlightAnalysisToggleController', require('./controllers/FlightAnalysisToggleController')).directive('rmFlightAnalysisToggle', require('./directives/FlightAnalysisToggleDirective'));